import React, { memo } from 'react';
import FastRewindIcon from '@/components/ui/icons/FastRewindIcon';
import LoadingIcon from '@/components/ui/icons/LoadingIcon';
import PauseButtonIcon from '@/components/ui/icons/PauseButtonIcon';
import PlayButtonIcon from '@/components/ui/icons/PlayButtonIcon';
import FastForwardIcon from '@/components/ui/icons/FastForwardIcon';

interface Props {
  status?: 'in-flight' | 'ready';
  isPlaying: boolean;
  isFirst: boolean;
  isLast: boolean;
  skipCallback: (direction: 'back' | 'forward') => void;
  pauseCallback: () => void;
  playCallback: () => void;
}

function Controls({
  status,
  isPlaying,
  isFirst,
  isLast,
  skipCallback,
  pauseCallback,
  playCallback,
}: Props) {
  return status === 'ready' ? (
    <div className="opacity-0 group-hover:opacity-100">
      <div
        data-first={isFirst}
        className="absolute left-2 top-1/2 z-10 h-6 w-10 -translate-y-1/2 cursor-pointer opacity-50 data-[first=true]:cursor-auto data-[first=true]:opacity-25"
        onClick={() => skipCallback('back')}>
        <FastRewindIcon />
      </div>
      <div
        data-last={isLast}
        className="absolute right-2 top-1/2 z-10 h-6 w-10 -translate-y-1/2 cursor-pointer opacity-50"
        onClick={() => skipCallback('forward')}>
        <FastForwardIcon />
      </div>
      {isPlaying ? (
        <div
          className="absolute left-1/2 top-1/2 z-10 size-14 -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-50"
          onClick={pauseCallback}>
          <PauseButtonIcon />
        </div>
      ) : (
        <div
          className="absolute left-1/2 top-1/2 z-10 size-14 -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-50"
          onClick={playCallback}>
          <PlayButtonIcon />
        </div>
      )}
    </div>
  ) : (
    <div className="absolute left-1/2 top-1/2 z-10 size-14 -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-50">
      <LoadingIcon className="size-12" />
    </div>
  );
}

export default memo(Controls);
